import {Injectable} from '@angular/core';
import {HttpBackend, HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {timeout} from 'rxjs/operators';
import {environment} from '@env/environment';
import {
    LocalPrinterClientStatus,
    PrinterClientBlock,
    PrinterClientCommand,
    PrinterClientCommandResult,
    PrinterClientList,
    PrinterDevice,
    PrinterPairingCode
} from '@app/domain/printer-client';

/** Servicio de impresión local de esta PC (puerto por defecto del jar). */
const LOCAL_PRINTER_CLIENT = 'http://localhost:9000';

/** Clientes de impresión: conectados (tekiwss), vinculados (backend) y el de esta PC (localhost). */
@Injectable({
    providedIn: 'root'
})
export class PrinterClientService {

    private baseUrl: string = environment.wsEndpointPrint;
    private apiUrl: string = environment.endpointApi;
    /** Sin interceptores: al servicio local no se le envía el token de sesión. */
    private localHttp: HttpClient;

    constructor(private http: HttpClient, httpBackend: HttpBackend) {
        this.localHttp = new HttpClient(httpBackend);
    }

    findAll(): Observable<PrinterClientList> {
        return this.http.get<PrinterClientList>(`${this.baseUrl}/printer-clients`, {headers: {hideLoader: 'S'}});
    }

    command(socketId: string, command: PrinterClientCommand, payload?: object): Observable<PrinterClientCommandResult> {
        return this.http.post<PrinterClientCommandResult>(`${this.baseUrl}/printer-clients/${socketId}/command`, {command, payload});
    }

    block(socketId: string): Observable<PrinterClientBlock> {
        return this.http.post<PrinterClientBlock>(`${this.baseUrl}/printer-clients/${socketId}/block`, {});
    }

    unblock(ruleId: string): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/printer-blocks/${ruleId}`);
    }

    findPairedDevices(): Observable<PrinterDevice[]> {
        return this.http.get<PrinterDevice[]>(`${this.apiUrl}/printer-devices`, {headers: {hideLoader: 'S'}});
    }

    createPairingCode(officeCode: string): Observable<PrinterPairingCode> {
        return this.http.post<PrinterPairingCode>(`${this.apiUrl}/printer-devices/pairing-codes`, {officeCode});
    }

    revokeDevice(deviceId: string): Observable<void> {
        return this.http.delete<void>(`${this.apiUrl}/printer-devices/${deviceId}`);
    }

    /** Falla (rápido) si en esta PC no está corriendo el servicio de impresión nuevo. */
    localStatus(): Observable<LocalPrinterClientStatus> {
        return this.localHttp.get<LocalPrinterClientStatus>(`${LOCAL_PRINTER_CLIENT}/api/status`).pipe(timeout(2500));
    }

    /** El jar de esta PC canjea el código contra la misma API que usa esta página (Teki o Cbet). */
    localPair(code: string): Observable<{ ok: boolean; officeCode?: string; message?: string }> {
        const apiUrl = this.apiUrl.replace(/\/api\/?$/, '');
        return this.localHttp.post<{ ok: boolean; officeCode?: string; message?: string }>(
            `${LOCAL_PRINTER_CLIENT}/api/pair`, {code, apiUrl}).pipe(timeout(20000));
    }
}
